/**
 * A chilli, for the priority heat scale. Lucide has no pepper.
 *
 * NOT DRAWN HERE ANY MORE. The hand-drawn one was a fat filled pod with a
 * stubby stem, and at the size it actually renders it read as a stomach —
 * which is the sort of thing only a person looking at the screen can tell
 * you, and Peter did. Two attempts at redrawing it is one more than the
 * problem is worth when a well-drawn one already exists.
 *
 * So this is Tabler's `pepper`, used under its MIT licence:
 *
 *   Tabler Icons — https://github.com/tabler/tabler-icons
 *   Copyright (c) 2020-2026 Paweł Kuna
 *   Licensed under the MIT License; see THIRD-PARTY-NOTICES.md at the repo
 *   root for the full notice this project is required to carry.
 *
 * Inlined rather than pulling in the package: one icon does not justify a
 * dependency, and the path is stable — it is a drawing, not an API.
 *
 * STROKED, ON THE SAME 24-UNIT GRID AS LUCIDE, at the same stroke width and
 * caps. That is the whole reason it sits correctly beside the other icons
 * where the old filled one always looked like a different set. It takes
 * `currentColor`, so tone is inherited like any other icon.
 */
export function Chilli({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      aria-hidden
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* The pod. */}
      <path d="M13 11c0 2.21 -2.239 4 -5 4s-5 -1.79 -5 -4a8 8 0 1 0 16 0a3 3 0 0 0 -6 0" />
      {/* The stalk — the one detail that makes it a chilli and not a bean. */}
      <path d="M16 8c0 -2 2 -4 4 -4" />
    </svg>
  );
}
